// if (window.location.href.indexOf("/loyalty") !== -1) {
// var urlParams = new URLSearchParams(window.location.search);
    
//     if (urlParams.has('email')) {
//         var email = urlParams.get('email');
        
//         console.log('Email:', email);
        
//         // You can use the email value as needed, for example:
//         $("#email").val(email);
//         // alert("Email: " + email); // Display an alert with the email value
//     } else {
//         console.log('Email parameter not found in the URL.');
//     }
// }


// $(document).ready(function () {
//   $('#custom-email-loyalty').click(function (e) { 
//     e.preventDefault();
//     var email_value = $('input[name="contact[email]"]').val();
//     window.location.href = "https://borrestad.no/a/loyalty?email=" + email_value;
    
//   });
// });

if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}